import { useMutation, useQueryClient } from '@tanstack/react-query'
import { syncPaymentGateway } from '../../services'
import { toast } from 'sonner'
import { BankQueryKeys } from '@/modules/bank/keys'

export default function useMutationSyncPaymentGateway() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: syncPaymentGateway,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.PaymentGateways],
			})
			queryClient.invalidateQueries({
				queryKey: [BankQueryKeys.ChannelCounts],
			})
			toast.success('อัปเดตยอดเงินธนาคารออโต้สำเร็จ')
		},
	})
}
